import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import SettingsSidebar from './SettingsSidebar';

/**
 * Layout component for settings routes (/dashboard/settings/*)
 * Shows header + settings sidebar on the left + content area
 */
export const SettingsLayout: React.FC = () => {
  return (
    <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
      {/* Header */}
      <AppHeader />

      {/* Main layout with settings sidebar */}
      <div className="flex-1 flex overflow-hidden">
        {/* Settings Sidebar - Always visible in settings context */}
        <SettingsSidebar />

        {/* Main content */}
        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SettingsLayout;
